const CurrentUserReducer = function(/*state, action*/) {
  var defaultState = {};
  var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];

  return state;
};

export default CurrentUserReducer;
